import { BlogPublicService } from './blogPublicService';
import { GlossaryPublicService } from './glossaryPublicService';
import { PagePublicService } from './pagePublicService';
import { PressReleasePublicService } from './pressReleasePublicService';
import { SuccessStoryPublicService } from './successStoryPublicService';
import { VideoPublicService } from './videoPublicService';
import { WhitePaperPublicService } from './whitePaperPublicService';

interface ServiceMapping {
    pagePublicService: PagePublicService;
    whitePaperPublicService: WhitePaperPublicService;
    glossaryPublicService: GlossaryPublicService;
    pressReleasePublicService: PressReleasePublicService;
    blogPublicService: BlogPublicService;
    successStoryPublicService: SuccessStoryPublicService;
    videoPublicService: VideoPublicService;
}

export abstract class PublicApiService {
    private static serviceInstances: Partial<ServiceMapping> = {};

    private static getService<T extends keyof ServiceMapping>(
        serviceClass: new () => ServiceMapping[T],
        serviceKey: T
    ): ServiceMapping[T] {
        return (
            PublicApiService.serviceInstances[serviceKey] ??
            (PublicApiService.serviceInstances[serviceKey] = new serviceClass())
        );
    }

    public static get pagePublicService(): PagePublicService {
        return PublicApiService.getService(PagePublicService, 'pagePublicService');
    }

    public static get whitePaperPublicService(): WhitePaperPublicService {
        return PublicApiService.getService(WhitePaperPublicService, 'whitePaperPublicService');
    }

    public static get glossaryPublicService(): GlossaryPublicService {
        return PublicApiService.getService(GlossaryPublicService, 'glossaryPublicService');
    }

    public static get pressReleasePublicService(): PressReleasePublicService {
        return PublicApiService.getService(PressReleasePublicService, 'pressReleasePublicService');
    }

    public static get blogPublicService(): BlogPublicService {
        return PublicApiService.getService(BlogPublicService, 'blogPublicService');
    }

    public static get successStoryPublicService(): SuccessStoryPublicService {
        return PublicApiService.getService(SuccessStoryPublicService, 'successStoryPublicService');
    }

    public static get videoPublicService(): VideoPublicService {
        return PublicApiService.getService(VideoPublicService, 'videoPublicService');
    }
}
